import { useMemo } from 'react';

import { productIndexes, CATEGORY_INDEX_MAPPING } from '../../commons/helpers';

const useMobileSearchFiltersTitle = algoliaIndexName => {
  const mobileSearchFiltersTitle = useMemo(() => {
    if (!algoliaIndexName) {
      return 'Products';
    }

    if (
      productIndexes?.includes(algoliaIndexName) ||
      algoliaIndexName === 'products' ||
      algoliaIndexName === CATEGORY_INDEX_MAPPING.products
    ) {
      return 'Products';
    }

    if (
      algoliaIndexName === 'pages' ||
      algoliaIndexName === CATEGORY_INDEX_MAPPING.pages
    ) {
      return 'Pages';
    }

    if (algoliaIndexName === 'categories') {
      return 'Categories';
    }

    if (
      algoliaIndexName === 'customer photos' ||
      algoliaIndexName === CATEGORY_INDEX_MAPPING['customer photos']
    ) {
      return 'Customer Photos';
    }

    if (
      algoliaIndexName === 'reviews' ||
      algoliaIndexName === CATEGORY_INDEX_MAPPING.reviews
    ) {
      return 'Reviews';
    }

    return 'Products';
  }, [algoliaIndexName]);

  return mobileSearchFiltersTitle;
};

export default useMobileSearchFiltersTitle;
